import createIcon from '../../createIcon';

/**
 * @component @name Straight
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEgNi44M0w5LjQxIDguNDFMOCA3TDEyIDNMMTYgN0wxNC41OSA4LjQxTDEzIDYuODNWMjFIMTFWNi44M1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Straight = createIcon('Straight', [
  ['path', { d: 'M11 6.83L9.41 8.41L8 7L12 3L16 7L14.59 8.41L13 6.83V21H11V6.83Z', key: 'uugc8j' }],
]);

export default Straight;
